import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 8px 12px;
  min-height: 48px;
  border: 1px solid #ebebeb;
  background-color: white;
  border-radius: 4px;
  color: #333;
  font-size: 16px;
  cursor: pointer;
`;

export const Input = styled.input<{ expand?: boolean }>`
  border-width: 0;
  width: ${({ expand }) => (expand ? '100%' : '160px')};
  height: 30px;
  line-height: 30px;

  &::placeholder {
    color: ${({ theme }) => theme.colors.gray700};
  }
`;

export const HashTag = styled.div`
  position: relative;
  margin: 3px 7px;
  height: 25px;
  line-height: 25px;
  border-radius: 16.5px;
  background-color: #666666;
  padding: 0 28px 0 10px;
  color: #fff;
  font-size: 11px;
  font-weight: 500;
`;

export const Delete = styled.div`
  position: absolute;
  top: 6px;
  right: 6px;
  width: 13px;
  height: 13px;
  background: #9b9b9b;
  border-radius: 50%;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 6px;
    height: 1px;
    background: #666666;
  }

  &::before {
    top: 6px;
    left: 4px;
    transform: rotate(-45deg);
  }

  &::after {
    top: 6px;
    left: 4px;
    transform: rotate(45deg);
  }
`;
